export default __webpack_public_path__ + "static/media/M1A_1.a2b76e4a.png";